import * as React from 'react';
import styles from './OnlineModal.module.scss';
import cn from 'classnames';
import { Button } from 'react-bootstrap';
import MicroIcon from 'components/assets/svg/microphone.svg';
import { UserVideo } from 'components';

import TestAudioPoster from 'components/assets/gif/test_audio.gif';
import TestAudioErrorPoster from 'components/assets/gif/not_allowed_audio.gif';

const SETTINGS = {
    width: 512,
    height: 256,
    step: 8,
    strokeStyle: '#47409D',
    gradient: [
        {
            stop: 0,
            color: 'rgb(161, 49, 151)',
        },
        {
            stop: 0.75,
            color: 'rgb(93, 205, 204)',
        },
        {
            stop: 1,
            color: 'rgb(35, 88, 133)',
        },
    ],
    fillStyle: 'white',
    lineWidth: 2,
    yOffset: 256 / 2,
    capacity: 64,
};

let frame = 0;

let arr: any[] = [];
let newarr: any[] = [];

const AudioTest: React.FC<IProps> = (props) => {
    const steps: IStep[] = [
        {
            index: 1,
            text: '1. Нажмите на кнопку «Начать проверку микрофона»',
            buttonText: 'Начать проверку микрофона',
        },
        {
            index: 2,
            text: '2. Разрешите сайту использовать ваш микрофон',
            buttonText: 'Начать проверку микрофона',
            disableButton: true,
            video: TestAudioPoster,
        },
        {
            index: 3,
            text: '3. Начните говорить или петь',
            buttonText: 'Начать проверку микрофона',
            disableButton: true,
            emoji: '😎',
        },
        {
            index: 4,
            text: '4. Если звуковая волна движется - все в порядке!',
            buttonText: 'Линия движется',
            emoji: '👍',
        },
    ];

    const errorText = [
        'Мы заметили, что вы отклонили запрос на предоставление доступа к микрофону. ',
        'В соответствии с Правилами проведения экзамена, вы должны предоставить доступ к микрофону.',
        'Для исправления ситуации, пожалуйста, следуйте видео-инструкции слева или нажмите на кнопку «Начать проверку заново».',
    ];
    const errorVideo = TestAudioErrorPoster;

    const audioAnalyzer = React.useRef<any>(null);
    const canvas = React.useRef<HTMLCanvasElement | null>(null);
    const canvasCtx = React.useRef<CanvasRenderingContext2D | null>(null);

    const [currStep, setStep] = React.useState<IStep | null>(steps[0]);
    const [isError, setError] = React.useState(false);
    const [stream, setStream] = React.useState<MediaStream | null>(null);


    const createGradient = (context: CanvasRenderingContext2D) => {
        const gradient = context.createLinearGradient(0, SETTINGS.height / 2, SETTINGS.width, SETTINGS.height / 2);

        SETTINGS.gradient.forEach(g => gradient.addColorStop(g.stop, g.color));

        return gradient;
    };

    const initCanvas = () => {
        if (!canvas.current) return;
        canvasCtx.current = canvas.current.getContext('2d');
        if (!canvasCtx.current) return;

        canvasCtx.current.strokeStyle = createGradient(canvasCtx.current);
        canvasCtx.current.lineWidth = SETTINGS.lineWidth;

        canvasCtx.current.clearRect(0, 0, canvas.current.width, canvas.current.height);
        canvasCtx.current.fillStyle = SETTINGS.fillStyle;
        canvasCtx.current.fillRect(0, 0, canvas.current.width, canvas.current.height);
        canvasCtx.current.beginPath();
        canvasCtx.current.moveTo(0, canvas.current.height / 2);
        canvasCtx.current.lineTo(canvas.current.width, canvas.current.height / 2);
        canvasCtx.current.stroke();
    };
    const clampY = (y: number) => Math.min(Math.max(y, 0), SETTINGS.height);
    const getPoints = (() => {
        audioAnalyzer.current.analyser.getByteTimeDomainData(audioAnalyzer.current.dataArray);


        const sliceWidth = SETTINGS.width / audioAnalyzer.current.bufferLength;
        let x = 0;
        const temparr = [];

        for (let i = 0; i < audioAnalyzer.current.bufferLength; i += 1) {
            const v = audioAnalyzer.current.dataArray[i] / 128.0;
            const y = v * SETTINGS.height;

            if (i % SETTINGS.capacity === 0) {
                temparr.push({
                    x,
                    y: y - SETTINGS.height / 2,
                });
            }

            x += sliceWidth;
        }


        return temparr;
    });

    const draw = () => {
        if (!canvas.current) return;
        if (!canvasCtx.current) return;

        if (frame % SETTINGS.step === 0) {
            newarr = getPoints();
        }

        if (frame === 0) {
            arr = getPoints();
        }

        canvasCtx.current.clearRect(0, 0, canvas.current.width, canvas.current.height);
        canvasCtx.current.fillStyle = SETTINGS.fillStyle;
        canvasCtx.current.fillRect(0, 0, canvas.current.width, canvas.current.height);

        canvasCtx.current.beginPath();

        canvasCtx.current.moveTo(0, canvas.current.height / 2);

        let i;
        for (i = 1; i < arr.length - 2; i += 1) {
            if (newarr.length > 0) {
                if (arr[i].y > newarr[i].y) {
                    const diff1 = (arr[i].y - newarr[i].y) / SETTINGS.step;
                    arr[i].y -= diff1;
                }

                if (arr[i].y < newarr[i].y) {
                    const diff2 = (newarr[i].y - arr[i].y) / SETTINGS.step;
                    arr[i].y += diff2;
                }

                if (arr[i + 1].y > newarr[i + 1].y) {
                    const diff3 = (arr[i + 1].y - newarr[i + 1].y) / SETTINGS.step;
                    arr[i + 1].y -= diff3;
                }

                if (arr[i + 1].y < newarr[i + 1].y) {
                    const diff4 = (newarr[i + 1].y - arr[i + 1].y) / SETTINGS.step;
                    arr[i + 1].y += diff4;
                }
            }

            const xc = (arr[i].x + arr[i + 1].x) / 2;
            const yc = (arr[i].y + arr[i + 1].y) / 2;
            canvasCtx.current.quadraticCurveTo(arr[i].x, clampY(arr[i].y), xc, clampY(yc));
        }

        canvasCtx.current.quadraticCurveTo(arr[i].x, clampY(arr[i].y), canvas.current.width, clampY(canvas.current.height / 2));
        canvasCtx.current.stroke();

        frame += 1;
        requestAnimationFrame(draw);
    };

    const init = (() => {
        if (!stream) return;

        const audioContext = new window.AudioContext();
        const source = audioContext.createMediaStreamSource(stream);
        const analyser = audioContext.createAnalyser();

        source.connect(analyser);

        analyser.fftSize = 2048;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        analyser.getByteTimeDomainData(dataArray);

        audioAnalyzer.current = {
            audioContext,
            source,
            analyser,
            dataArray,
            bufferLength,
        };

        initCanvas();
        draw();
    });

    React.useEffect(() => () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    }, [stream]);


    const handleStart = React.useCallback(async () => {
        if (navigator.mediaDevices) {
            try {
                setStep(steps[1]);
                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                });

                setStep(steps[3]);
                setStream(mediaStream);
            } catch (e) {
                setError(true);
            }
        }
    }, []);

    React.useEffect(() => {
        if (stream) {
            init();
        }
    }, [stream]);

    const handler = React.useMemo(() => {
        if (isError) {
            return () => {
                setStep(steps[0]);
                setError(false);
            };
        }
        if (!currStep) {
            return props.onNextTest;
        }

        if (currStep.index === 1) {
            return handleStart;
        }

        if (currStep.index === 4) {
            return () => setStep(null);
        }

        return () => {
        };
    }, [currStep, isError]);

    const buttonText = React.useMemo(() => {
        if (isError) {
            return 'Начать проверку заново';
        }

        if (currStep) {
            return currStep.buttonText;
        }

        return 'Перейти к следующему шагу';
    }, [currStep, isError]);


    return (
      <div className={styles.testContainer}>
          {(!currStep || currStep.index > 2) && !isError && (
            <canvas ref={canvas} height={SETTINGS.height} width={SETTINGS.width} />
          )}
          {currStep && currStep.index === 2 && (
            <UserVideo
              poster={isError ? errorVideo : currStep.video}
              containerClassName={styles.videoContainer}
              className={cn(styles.video, styles.autoHeight)}
              withoutFullScreen
            />
          )}
          <div className={styles.testStepper}>

              {currStep ? (
                isError ? (
                  <>
                      <h4>Нет доступа к микрофону ️<span aria-label="who knows emoji" role="img">🤷🏻‍♂</span>️</h4>
                      {errorText.map((t, i) => (
                        <div key={i} className={styles.errorText}>
                            {t}
                        </div>
                      ))}
                  </>
                ) : (
                  <>
                      <h4>Как пройти тест микрофона?</h4>
                      <ul>
                          {steps.map((step, i) => (
                            <li key={step.index} className={cn({ [styles.active]: i + 1 === currStep.index })}>
                                {step.text} {step.emoji ? <span>{step.emoji}</span> : null}
                            </li>
                          ))}
                      </ul>
                  </>
                )
              ) : (
                <div className={styles.end}>
                    <img src={MicroIcon} alt="ScreenIcon" />
                    Микрофон в порядке!
                </div>
              )}
              <Button
                className="mt-5"
                disabled={Boolean(currStep && currStep.disableButton && !isError)}
                onClick={handler}
              >
                  {buttonText}
              </Button>
          </div>
      </div>
    );
};

interface IProps {
    onNextTest: () => void;
}

interface IStep {
    index: number;
    text: string;
    buttonText: string;
    disableButton?: boolean;
    video?: string;
    emoji?: string;
}

export default AudioTest;
